






























import Vue, { PropType } from 'vue'
import { Client } from '~/api/Agency/agency.interface'
import { copyRemittance } from '~/api/Remittances/remittances.api'
import CreateDialog from '~/components/CreateDialog.vue'
import IconButton from '~/components/IconButton.vue'
import { Step } from '~/utils/interfaces'
import {
  DeliveryCurrenciesEnum,
  Remittance,
} from '~/utils/interfaces/remittance.interface'
import Payment from './Payment.vue'
export default Vue.extend({
  components: { IconButton, CreateDialog, Payment },
  props: {
    item: {
      type: Object as PropType<Remittance>,
      required: true,
    },
    clientDestinyObj: {
      type: Object as PropType<Client>,
    },
  },
  data() {
    return {
      loading: false,
      model: false,
      DeliveryCurrenciesEnum,
    }
  },
  methods: {
    async onSuccess() {
      this.loading = true
      try {
        const response = await (this.$refs.payment as Step).onNext()
        if (!response) {
          this.loading = false
          return
        }
        await copyRemittance({
          ...(response as {
            delivery_currency: DeliveryCurrenciesEnum
            amount: string
            description: string
            tariff: string
            distribute_with_network: boolean
          }),
          remittance: this.item.remittance,
          request_signature: false,
        })
        this.$emit('refresh')
        this.model = false
      } finally {
        this.loading = false
      }
    },
  },
})
